import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assests/images/weblogo.png';

function NavbarUi() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = ['Home', 'Features', 'About'];

  return (
    <>
      {/* ── NAVBAR BAR (always on top z-50) ── */}
      <nav
        className={`fixed top-0 w-full z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-[#0a0a1a]/95 backdrop-blur-xl shadow-2xl'
            : 'bg-transparent'
        }`}
      >
        {/* Desktop — 3-col grid for perfect centering */}
        <div className="hidden lg:grid lg:grid-cols-3 items-center container mx-auto px-4 py-4">
          <div className="flex items-center">
            <Link to="/">
              <img src={logo} alt="Ellipticline Logo" className="h-11 w-auto object-contain" />
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8">
            {navItems.map((item) => (
              <a
                key={item}
                href="#"
                className="text-gray-400 hover:text-white text-sm font-medium relative group transition-colors duration-200"
              >
                {item}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-violet-500 group-hover:w-full transition-all duration-300" />
              </a>
            ))}
          </div>

          <div className="flex items-center justify-end gap-4">
            <Link to="/login" className="text-gray-300 hover:text-white text-sm font-medium px-3 py-2 transition-colors">
              Sign In
            </Link>
            <Link to="/signup" className="bg-violet-600 hover:bg-violet-500 text-white text-sm font-semibold px-2 py-2.5 rounded-xl transition-all duration-200 hover:shadow-lg hover:shadow-violet-500/25">
              Get Started
            </Link>
          </div>
        </div>

        {/* Mobile topbar — logo left, hamburger/X right */}
        <div className="lg:hidden flex items-center justify-between px-4 py-4">
          <Link to="/">
            <img src={logo} alt="Ellipticline Logo" className="h-9 w-auto object-contain" />
          </Link>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-8 h-8 flex flex-col justify-center items-center gap-1.5"
            aria-label="Toggle menu"
          >
            <span className={`block w-6 h-0.5 bg-white rounded-full transition-all duration-300 origin-center ${isOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-6 h-0.5 bg-white rounded-full transition-all duration-300 ${isOpen ? 'opacity-0 scale-x-0' : ''}`} />
            <span className={`block w-6 h-0.5 bg-white rounded-full transition-all duration-300 origin-center ${isOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>
      </nav>

      {/* ── MOBILE FULLSCREEN OVERLAY (z-49, behind navbar) ── */}
      <div
        className={`lg:hidden fixed inset-0 z-[49] bg-[#07071a] flex flex-col transition-all duration-300 ease-in-out ${
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        {/* Push content below the navbar height */}
        <div className="h-[65px]" />

        {/* Nav Links — centered */}
        <div className="flex flex-col items-center px-6 border-t border-white/10">
          {navItems.map((item) => (
            <a
              key={item}
              href="#"
              onClick={() => setIsOpen(false)}
              className="w-full text-center py-4 text-base font-medium text-gray-300 hover:text-white border-b border-white/10 last:border-0 transition-colors"
            >
              {item}
            </a>
          ))}
        </div>

        {/* CTA Buttons pinned to bottom */}
        <div className="mt-auto px-6 pb-10 flex flex-col gap-3">
          <Link
            to="/login"
            onClick={() => setIsOpen(false)}
            className="w-full text-center border border-white/20 text-white text-xs font-medium px-4 py-3 rounded-xl hover:border-violet-500 hover:bg-violet-500/10 transition-all"
          >
            Sign In
          </Link>
          <Link
            to="/signup"
            onClick={() => setIsOpen(false)}
            className="w-full text-center bg-violet-600 text-white text-xs font-semibold px-2 py-3 rounded-xl hover:bg-violet-500 transition-colors"
          >
            Get Started
          </Link>
        </div>
      </div>
    </>
  );
}

export default NavbarUi;